import {default as formatIcs} from './formatIcs';
import {default as formatName} from './formatName';
import {default as capitalize} from './capitalize';
import {default as obfuscateIban} from './obfuscateIban';
import {default as obfuscatePhone} from './obfuscatePhone';
import {default as upperCase} from './uppercase';

export default {formatIcs, formatName, capitalize, obfuscateIban, obfuscatePhone, upperCase}